import { Action } from 'redux-actions';
import { all, put, select, takeEvery } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { executeSagaRequest } from '@savgroup-front-common/core/services';

import { getUserInformationByIdRequest } from '../../api/Authorization/getUserInformationByIdQuery';

import { GetUserPayload } from './actionCreators';
import * as types from './actionTypes';
import { selectGetUserIsLoading, selectGetUserWasLoaded } from './selectors';

function* getUserByIdWorker({
  payload,
}: {
  payload: GetUserPayload;
}): Generator {
  const { userId } = payload;

  const isLoading = yield select(selectGetUserIsLoading, {
    userId,
  });
  const wasLoaded = yield select(selectGetUserWasLoaded, {
    userId,
  });

  if (isLoading || wasLoaded) {
    return;
  }

  yield executeSagaRequest(
    types.GET_USER_BY_ID,
    getUserInformationByIdRequest({ userId }),
    { indexer: userId },
  );

  yield put(types.GET_USER_BY_ID.end({ userId }));
}
function* getUserByIdWatcher(): Generator {
  yield takeEvery<Action<GetUserPayload>>(
    types.GET_USER_BY_ID.BASE,
    getUserByIdWorker,
  );
}

export default function* userSaga(): Generator {
  try {
    yield all([getUserByIdWatcher()]);
  } catch (error) {
    logCritical(error);
  }
}
